<template>
  <div v-if="error">
    <at-alert type="danger" dismissible>
      {{ message }}
    </at-alert>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { AtAlert } from '@packages/aliftech-ui';

  const props = defineProps({
    error: {
      type: Object,
      default: null,
    },
  });

  const { t } = useI18n();

  const message = computed(() => {
    return t(`shared.lib.keycloak.error.${props.error.response.data.error}`) || t(`shared.lib.keycloak.defaultError`);
  });
</script>
